// extracted by css-extract-rspack-plugin
export default {"group":"PqxVZEMDVM8JgOaG"};